<template>
  <div class="flex">
    <custom-label v-if="label" :item-field-name="label" />

    <v-textarea
      dense
      rounded
      :prepend-inner-icon="icon"
      hide-details="auto"
      :placeholder="placeholder"
      filled
      :background-color="$vuetify.theme.themes.light.inputBackgroundColor"
      v-bind="$attrs"
      v-on="$listeners"
      :class="{ 'small-input': small }"
    >
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="props">
        <slot :name="name" v-bind="props" /> </template
    ></v-textarea>
  </div>
</template>

<script>
import customLabel from '@/components/customFormLabel/customLabel';
export default {
  name: 'FletrixTextarea',
  components: {
    customLabel,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    small: {
      Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
